var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.25,
    height: 38,
    viewBox: "0 0 33.25 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15355",
    "data-name": "Trazado 15355",
    d: "M8.313-33.25A1.189,1.189,0,0,1,9.5-32.062V-28.5H23.75v-3.562a1.189,1.189,0,0,1,1.188-1.187,1.189,1.189,0,0,1,1.188,1.188V-28.5H28.5a4.752,4.752,0,0,1,4.75,4.75V0A4.754,4.754,0,0,1,28.5,4.75H4.75A4.752,4.752,0,0,1,0,0V-23.75A4.75,4.75,0,0,1,4.75-28.5H7.125v-3.562A1.189,1.189,0,0,1,8.313-33.25ZM30.875-19H2.375V0A2.374,2.374,0,0,0,4.75,2.375H28.5A2.372,2.372,0,0,0,30.875,0ZM28.5-26.125H4.75A2.374,2.374,0,0,0,2.375-23.75v2.375h28.5V-23.75A2.372,2.372,0,0,0,28.5-26.125Z",
    transform: "translate(0 33.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDetail);
export default __webpack_public_path__ + "static/media/calendar-detail.e060dd25.svg";
export { ForwardRef as ReactComponent };